import { get } from '../../../utils/get';
import { getKeys as _getKeys } from '../../../adapters/utils';
var IDs = {
  NAME: 'blog-category.name',
  DESCRIPTION: 'blog-category.description',
  IMAGE: 'blog-category.image',
  IMAGE_HEIGHT: 'blog-category.image.height',
  IMAGE_WIDTH: 'blog-category.image.width',
  PAGE_URL: 'blog-category.url',
  PREV_PAGE_URL: 'blog-category.prevUrl',
  NEXT_PAGE_URL: 'blog-category.nextUrl'
};
var userVisible = [];
export default {
  IDs: IDs,
  getData: function getData(item) {
    var _ref;

    return _ref = {}, _ref[IDs.NAME] = get(item, 'category.title'), _ref[IDs.DESCRIPTION] = get(item, 'category.description'), _ref[IDs.IMAGE] = get(item, 'category.image.url'), _ref[IDs.IMAGE_HEIGHT] = get(item, 'category.image.height'), _ref[IDs.IMAGE_WIDTH] = get(item, 'category.image.width'), _ref[IDs.PAGE_URL] = get(item, 'category.canonicalUrl'), _ref[IDs.PREV_PAGE_URL] = get(item, 'category.prevUrl'), _ref[IDs.NEXT_PAGE_URL] = get(item, 'category.nextUrl'), _ref;
  },
  getLegacySeoBlob: function getLegacySeoBlob() {},
  getSlug: function getSlug() {
    return '';
  },
  updateItemDataWithSlug: function updateItemDataWithSlug(item) {
    return item;
  },
  getBiData: function getBiData() {},
  getKeys: function getKeys() {
    return _getKeys(IDs, userVisible);
  }
};